function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var TransactionTeaserTemplate = require('./transaction-teaser.template');
var _require = require('../explorer-format'),
  formatTransactionsForTeaser = _require.formatTransactionsForTeaser;
var TransactionTeaser = /*#__PURE__*/function () {
  function TransactionTeaser(app, mod) {
    _classCallCheck(this, TransactionTeaser);
    this.app = app;
    this.mod = mod;
  }
  return _createClass(TransactionTeaser, [{
    key: "render",
    value: function render(container) {
      if (!container) {
        return;
      }
      var loading = !this.mod.transactionsReady;
      var error = this.mod.transactionsError ? this.app.browser.escapeHTML(this.mod.transactionsError) : null;
      var transactions = loading ? [] : formatTransactionsForTeaser(this.app, this.mod.transactions || []);
      this.app.browser.replaceElementContentBySelector(TransactionTeaserTemplate({
        transactions: transactions,
        loading: loading,
        error: error,
        loadingMessage: 'Fetching transaction data. Please be patient while we load recent transactions from the network.'
      }), container);
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      document.querySelectorAll('.transaction-teaser .explorer-transaction-card[data-tx-signature]').forEach(function (el) {
        var navigate = function navigate(event) {
          var _event$target, _event$preventDefault;
          if (event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.closest('.explorer-pubkey-link')) {
            return;
          }
          event === null || event === void 0 || (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
          var signature = el.getAttribute('data-tx-signature');
          if (!signature) {
            return;
          }
          var blockHash = el.getAttribute('data-block-hash') || '';
          if (!blockHash) {
            blockHash = _this.mod.resolveBlockHash('', el.getAttribute('data-block-id'));
          }
          if (!blockHash) {
            return;
          }
          _this.mod.renderBlock(blockHash, {
            expandTxSignature: signature
          });
        };
        el.onclick = navigate;
        el.onkeydown = function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            navigate(event);
          }
        };
      });
    }
  }]);
}();
module.exports = TransactionTeaser;